
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({})
export default class AppModal<T = unknown> extends Vue {
  public modalState!: boolean;

  public close(_value: T): void {
    throw new Error("Method not implemented");
  }

  public throw(_error: Error): void {
    throw new Error("Method not implemented");
  }

  /**
   * We need to close modal current route was changed by a user or application itself
   */
  @Watch("$route", { deep: true })
  public onRouteChanged(): void {
    if (this.modalState) {
      this.throw(new Error("Modal was forced to close due to route changed. "));
    }
  }
}
